import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import * as _ from 'lodash';
import { AdminSuppliesAddPage } from "../admin-supplies-add/admin-supplies-add";
import { AdminSuppliesUploadPage } from "../admin-supplies-upload/admin-supplies-upload";
import { Subject } from "rxjs";
import moment from "moment";

@IonicPage()
@Component({
  selector: "page-admin-supplies",
  templateUrl: "admin-supplies.html"
})
export class AdminSuppliesPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  public suppliesList: any[];
  public filteredSuppliesList: any[];

  searchFilter: string = "";
  clinic_name: string = null;
  clinic_id: string = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private modalCtrl: ModalController
  ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database
      .getSupplies()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((supplies) => {
        this.suppliesList = supplies;
        this.filteredSuppliesList = supplies;
      });
    });
  }

  updateFilter() {
    this.filteredSuppliesList = this.suppliesList.filter((supply) => {
      return supply.name.toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1 ||
        supply.category.toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1 ||
        supply.din.indexOf(this.searchFilter) !== -1;
    })
  }

  resetFilter() {
    this.searchFilter = "";
    this.filteredSuppliesList = this.suppliesList;
  }

  ngOnDestroy() {
    console.log('Leave supplies admin and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  supplyAddEdit(supply) {
    let supplyModal = this.modalCtrl.create(AdminSuppliesAddPage, {'supplydata': supply} , {showBackdrop: true, enableBackdropDismiss: false});
    supplyModal.present();
  }

  deleteSupply(supply)  {
    let confirm = this.alertCtrl.create({
      title: "Delete Supply",
      message:
        "Are you sure you would like to remove this supply from the master list?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.database.deleteSupply(supply.din)
            .then(() => {})
            .catch((error) => {});
          }
        }
      ]
    });
    confirm.present();
  }

  uploadSupplies()  {
    let uploadModal = this.modalCtrl.create(AdminSuppliesUploadPage, null, {showBackdrop: true, enableBackdropDismiss: false});
    uploadModal.present();
  }

  downloadCsv() {
    let csvString = "din, name, created_date, category, size, strength, unit";
    for (const supply of this.suppliesList) {
      csvString = csvString.concat(`\n${supply.din}, ${supply.name}, ${moment.unix(supply.createdAt.seconds).format("YYYY-MM-DD")}, ${supply.category}, ${supply.size}, ${supply.strength}, ${supply.unit}`);
    }

    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', "supplies.csv");
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-supplies/admin-supplies.ts